import { Button, Col, Container, Row } from "react-bootstrap";
import React from "react";
import { SituacaoPedido } from "../../consts/situacao_pedido";

export const PedidosFilterSituacao = ({
    onGetStyle,
    constantes,
    loading,
    onClick
}) => {
    const getButtonStyle = (situacao) => {
        const baseStyle = onGetStyle(situacao);
        
        if (situacao === SituacaoPedido.LIBERADO) {
            return {
                ...baseStyle,
            };
        }
        
        return { ...baseStyle };
    };

    const getResponsiveStyle = (baseStyle) => {
        return {
            ...baseStyle,
            fontSize: "0.85rem",
            padding: "6px 12px",
            whiteSpace: "nowrap",
            width: "100%",
            "@media (min-width: 768px)": {
                fontSize: "0.9rem",
                padding: "8px 14px",
            },
            "@media (min-width: 992px)": {
                fontSize: "0.95rem",
                padding: "10px 18px",
            },
            "@media (min-width: 1200px)": {
                fontSize: "1rem",
                padding: "12px 24px",
            },
        };
    };

    const containerStyle = {
        margin: "5px 0",
        padding: "0 5px",
    };

    const [isLargeScreen, setIsLargeScreen] = React.useState(
        typeof window !== 'undefined' ? window.innerWidth >= 1390 : false
    );

    React.useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 1390);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isLargeScreen) {
        return (
            <Container style={containerStyle}>
                <div
                    className="d-flex flex-nowrap gap-2"
                    style={{
                        overflowX: "auto",
                        paddingBottom: "5px",
                        maxWidth: "100%",
                    }}
                >

                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO}
                    >
                        {constantes.Bloqueado}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.LIBERADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.LIBERADO}
                    >
                        {constantes.Liberado}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.CANCELADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.CANCELADO}
                    >
                        {constantes.Cancelado}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.PENDENTE))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.PENDENTE}
                    >
                        {constantes.Pendente}
                    </Button>
<Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_FINANCEIRO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_FINANCEIRO}
                    >
                        {constantes.BloqueadoFinanceiro}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_COMERCIAL))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_COMERCIAL}
                    >
                        {constantes.BloqueadoComercial}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_TECNICO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_TECNICO}
                    >
                        {constantes.BloqueadoTecnico || "Bloqueado Tec. (Análise técnica)"}
                    </Button>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.FATURADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.FATURADO}
                    >
                        {constantes.Faturado}
                    </Button>
                </div>
            </Container>
        );
    }

    return (
        <Container style={containerStyle}>
            <Row className="g-1">
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO}
                        className="w-100"
                    >
                        {constantes.Bloqueado}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.LIBERADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.LIBERADO}
                        className="w-100"
                    >
                        {constantes.Liberado}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.CANCELADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.CANCELADO}
                        className="w-100"
                    >
                        {constantes.Cancelado}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.PENDENTE))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.PENDENTE}
                        className="w-100"
                    >
                        {constantes.Pendente}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_FINANCEIRO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_FINANCEIRO}
                        className="w-100"
                    >
                        {constantes.BloqueadoFinanceiro}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_COMERCIAL))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_COMERCIAL}
                        className="w-100"
                    >
                        {constantes.BloqueadoComercial}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.BLOQUEADO_TECNICO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.BLOQUEADO_TECNICO}
                        className="w-100"
                    >
                        {constantes.BloqueadoTecnico || "Bloqueado Tec. (Análise técnica)"}
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <Button
                        style={getResponsiveStyle(getButtonStyle(SituacaoPedido.FATURADO))}
                        disabled={loading}
                        onClick={onClick}
                        situacao={SituacaoPedido.FATURADO}
                        className="w-100"
                    >
                        {constantes.Faturado}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}
